import React from 'react';
import { ImportValidationModalTemplate } from 'themes/application/import/components';
import { observer } from 'mobx-react';
import { ImportValidationModalStore } from 'application/import/stores';
import { setCurrentView } from 'core/utils';

@setCurrentView((rootStore, componentProps) => new ImportValidationModalStore(rootStore, componentProps), 'importValidationModalStore')
@observer
class ImportValidationModal extends React.Component {
    render() {
        return <ImportValidationModalTemplate {...this.props} />
    }
}

export default ImportValidationModal;